import { render } from "./Demos.vue?vue&type=template&id=c02cb676&scoped=true"
import script from "./Demos.vue?vue&type=script&lang=js"
export * from "./Demos.vue?vue&type=script&lang=js"

import "./Demos.vue?vue&type=style&index=0&id=c02cb676&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02cb676"]])

export default __exports__